<!-- 新版 -->
<template>
  <div class="school-home">
    <!-- 头部工具栏 -->
    <Card class="sticky">
      <Row>
        <Col class="flex flex-start" span="8">
          <Button type="primary" shape="circle" icon="md-refresh" :loading="loadingFun" @click="getNewStatisc"></Button>
          <div style="margin-left:20px;">截止：{{ timeFont }}</div>
        </Col>
        <Col class="flex flex-end" span="16">
          <div class="basic-info flex">
            <div v-for="item of basicData" :key="item.label" class="info-item">
              {{ item.label }}：{{ item.value }}
            </div>
          </div>
          <div class="select">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
            <!-- <Select
              v-model="yearCode"
              style="width: 150px; margin-right: 20px"
              @on-change="handleChangeSelect('ENT_YEAR_CODE', 'yearCode')"
            >
              <Option v-for="item in yearList" :key="item.value" :value="item.value">{{ item.label + '学年' }}</Option>
            </Select>
            <Select v-model="termCode" style="width: 100px" @on-change="handleChangeSelect('TERM_CODE', 'termCode')">
              <Option v-for="item in termList" :key="item.value" :value="item.value">{{ item.label }}</Option>
            </Select> -->
          </div>
          <div class="tool-btn">
            <Icon class="full-screen" type="ios-expand" size="20" title="全屏" @click="handleFullScreen"></Icon>
          </div>
        </Col>
      </Row>
    </Card>
    <!-- 内容区 -->
    <main>
      <div class="card-box flex">
        <Card v-for="(item, index) in satisObj" :key="index" class="card-item">
          <div class="card-title">{{ item.title }}</div>
          <div class="card-content">
            <template v-if="+item.num">
              <!-- 动画组件 -->
              <CountTo
                class="card-num"
                :start-val="item.startVal || 0"
                :end-val="item.num"
                :duration="1500"
                :decimals="item.decimals || 0"
              ></CountTo>
              <!-- <span class="card-num">{{ item.showNum }}</span> -->
              <span class="card-unit">{{ item.unit }}</span>
            </template>
            <template v-else>
              <div class="no-data">暂未更新</div>
            </template>
          </div>
        </Card>
      </div>

      <!-- 饼状图 -->
      <div class="piewrap">
        <div class="picebox">
          <div class="wraptitle">
            <span class="titlefont">素质课程报名情况</span>
            <Button type="primary" shape="circle" icon="md-arrow-forward" @click="goDeatil(1)">详情</Button>
          </div>
          <div class="dh">
            <itemPie :piedata="coursepieData" :title="'素质课程报名情况'"></itemPie>
          </div>
        </div>
        <div class="picebox">
          <div class="wraptitle">
            <span class="titlefont">托管课程报名情况</span>
            <Button type="primary" shape="circle" icon="md-arrow-forward" @click="goDeatil(3)">详情</Button>
          </div>
          <div class="dh">
            <itemPie :piedata="depositpieData" :title="'托管课程报名情况'"></itemPie>
          </div>
        </div>
      </div>

      <div class="piewrap">
        <div class="picebox">
          <div class="wraptitle">
            <span class="titlefont">素质课程开班情况</span>
            <Button type="primary" shape="circle" icon="md-arrow-forward" @click="goDeatil(2)">详情</Button>
          </div>
          <div class="dh">
            <itemPie :piedata="classCoursepieData" :title="'素质课程开班情况'"></itemPie>
          </div>
        </div>
        <div class="picebox">
          <div class="wraptitle">
            <span class="titlefont">托管课程开班情况</span>
            <Button type="primary" shape="circle" icon="md-arrow-forward" @click="goDeatil(4)">详情</Button>
          </div>
          <div class="dh">
            <itemPie ref="classDepositpieData" :piedata="classDepositpieData" :title="'托管课程开班情况'"></itemPie>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatTime } from '@/utils/utils';
import { cardList } from './assets/data/indexData.js';
import CountTo from 'vue-count-to';
import itemPie from '@c/DataPieForEdu/index.vue';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms';
import { getBigdataReport, getByDictCode, getStuEnrollNum, getEnrollNum, getStatisticInfoApi, getPaymentInfo, getRefundInfo, getCourseNum, getCourseClassNum, getCourseClassDetailNum, statEnrollNumOfCourseTypeKind, statOpenClassNumOfCourseTypeKind } from '@/request/educationAdmin';

export default {
  name: 'SchoolHomes',
  components: {
    CountTo, itemPie, CascaderYearTerms
  },
  data() {
    return {
      timeFont: '',
      loadingFun: false,
      satisObj: {
        enrollNum: { title: '报名人次', num: 0, unit: '人/次' },
        stuEnrollNum: { title: '报名人数', num: 0, unit: '人' },
        signPercent: { title: '报名率', num: 0, unit: '%', decimals: 2 },
        payment: { title: '收款总额', num: 0, unit: '元', decimals: 2 },
        refundNum: { title: '退款单数', num: 0, unit: '单' },
        refundPrice: { title: '退款总额', num: 0, unit: '元', decimals: 2 },
        courseNum: { title: '开设课程数', num: 0, unit: '课' },
        courseSignNum: { title: '人均报课数', num: 0, unit: '课', decimals: 1 },
        courseClassNum: { title: '开班数', num: 0, unit: '班' },
        courseClassDetailNum: { title: '开班总节次数', num: 0, unit: '节次' }
      },
      // 素质课人数
      coursepieData: [],
      // 托管人数
      depositpieData: [],
      classCoursepieData: [],
      classDepositpieData: [],
      /* 数据概览 */
      basicData: [
        {
          label: '学校数',
          value: 0
        },
        {
          label: '机构数',
          value: 0
        },
        {
          label: '学生数',
          value: 0
        }
      ],
      // 学年
      yearList: [],
      yearCode: undefined,
      // 学期
      termList: [],
      termCode: undefined,
      cardList: cardList,
      timer: 0, // 定时器
      intervalNum: 0, // 定时器计数器
      timeoutDelay: 1000 * 60 * 60 // 一个小时更新一次数据
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted() {
    // this.init();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    goDeatil(index) {
      // 1 素质课 3托管课
      if (index == 1 || index == 3) {
        this.$router.push({
          path: '/orderCenter/order/orderTable',
          query: { oType: index, yearCode: this.yearCode, termCode: this.termCode }
        });
      }
      if (index == 2 || index == 4) {
        this.$router.push({
          path: '/courseSchedulCenter/divideClassManage/list',
          query: { oType: index == 2 ? 1 : 2, yearCode: this.yearCode, termCode: this.termCode }
        });
      }
    },
    async init() {
      // await this.getTermList();
      this.getNewStatisc();
      // this.getMain();
      // this.initInterval(this.timeoutDelay);
    },
    onCascaderChange(v) {
      console.log(v, '年度资源学期');
      this.yearCode = v[0];
      this.termCode = v[1];
      this.init();
    },
    initInterval() {
      this.timer = setInterval(() => {
        this.intervalNum++;
        this.getMain();
        if (this.intervalNum > 2) { // 3次清空一次定时器
          this.intervalNum = 0;
          clearInterval(this.timer);
          this.initInterval();
        }
      }, this.timeoutDelay);
    },
    /* 数据概览 */
    // async getTermList() {
    //   const data = [
    //     {
    //       orgId: this.userInfo.orgId,
    //       dictCode: 'ENT_YEAR_CODE',
    //       list: 'yearList',
    //       model: 'yearCode',
    //       jsSort: (a, b) => b.value - a.value
    //     },
    //     {
    //       orgId: this.userInfo.orgId,
    //       dictCode: 'TERM_CODE',
    //       list: 'termList',
    //       model: 'termCode'
    //     }
    //   ];
    //   const arr = data.map(({ orgId, dictCode }) => getByDictCode({ orgId, dictCode }));
    //   const res = await Promise.all(arr);
    //   res.forEach((item, index) => {
    //     if (item.status === 200) {
    //       const dictValue = JSON.parse(item.message.dictValue);
    //       const { list, model, jsSort, dictCode } = data[index];
    //       this[list] = dictValue.map(item => ({ label: item.value, value: item.sort }));
    //       jsSort && this[list].sort(jsSort); // 学年排序
    //       // this[model] = this[list][0].value;
    //       const preSelect = localStorage.getItem(dictCode);
    //       if (preSelect) {
    //         this[model] = +preSelect;
    //       } else {
    //         // 2022-07-05 没有选择的情况下，需求暂时处理为默认选中 2021-2022学年 暑假
    //         if (dictCode === 'ENT_YEAR_CODE') {
    //           this[model] = this[list].find(item => item.label === '2022-2023').value;
    //         } else {
    //           this[model] = this[list].find(item => item.label === '第二学期').value;
    //         }
    //         localStorage.setItem(dictCode, this[model]);
    //       }
    //     }
    //   });
    // },

    async getNewStatisc() {
      this.loadingFun = true;
      const time = new Date();
      this.timeFont = formatTime(time, 'yyyy-MM-dd hh:mm:ss');
      // this.timeFont = this.timestampToTime(time.toLocaleString('en-US', { hour12: false }).split(' '));
      const data = {
        yearCode: this.yearCode,
        termCode: this.termCode
      };

      const { orgId: bureauId } = this.userInfo;
      const topParameter = {
        bureauId,
        ...data
      };
      const topresult = await getStatisticInfoApi(topParameter);
      console.log('topresult', topresult);
      if (topresult.status === 200) {
        const { studentsNumber, schoolNumber, orgNumber } = topresult.message;
        this.basicData = [
          {
            label: '学校数',
            value: schoolNumber
          },
          {
            label: '机构数',
            value: orgNumber
          },
          {
            label: '学生数',
            value: studentsNumber
          }
        ];
      }
      // return;

      // 饼状图
      const params = { courseTypeAttr: 1, ...data };
      const params2 = { courseTypeAttr: 2, ...data };
      statEnrollNumOfCourseTypeKind(params).then(res => {
        const { status, message } = res;
        if (status == 200 && message) {
          const ar = [];
          message.map((item, index) => {
            const obj = {};
            obj.name = item.courseTypeKindName;
            obj.value = item.cnt;
            ar.push(obj);
          });
          this.coursepieData = ar;
        }
      });

      statEnrollNumOfCourseTypeKind(params2).then(res => {
        const { status, message } = res;
        if (status == 200 && message) {
          const ar = [];
          message.map((item, index) => {
            const obj = {};
            obj.name = item.courseTypeKindName;
            obj.value = item.cnt;
            ar.push(obj);
          });
          this.depositpieData = ar;
        }
      });
      statOpenClassNumOfCourseTypeKind(params).then(res => {
        const { status, message } = res;
        if (status == 200 && message) {
          const ar = [];
          message.map((item, index) => {
            const obj = {};
            obj.name = item.courseTypeKindName;
            obj.value = item.cnt;
            ar.push(obj);
          });
          this.classCoursepieData = ar;
        }
      });
      statOpenClassNumOfCourseTypeKind(params2).then(res => {
        const { status, message } = res;
        if (status == 200 && message) {
          const ar = [];
          message.map((item, index) => {
            const obj = {};
            obj.name = item.courseTypeKindName;
            obj.value = item.cnt;
            ar.push(obj);
          });
          this.classDepositpieData = ar;
        }
      });

      // 课程数
      getCourseNum(data).then(res => {
        const { status, message } = res;
        if (status == 200) {
          this.$set(this.satisObj.courseNum, 'num', message);
        }
      });
      // 课程数
      getCourseClassNum(data).then(res => {
        const { status, message } = res;
        if (status == 200) {
          this.$set(this.satisObj.courseClassNum, 'num', message ? Number(message) : 0);
        }
      });
      //
      getCourseClassDetailNum(data).then(res => {
        const { status, message } = res;
        if (status == 200) {
          this.$set(this.satisObj.courseClassDetailNum, 'num', message ? Number(message) : 0);
        }
      });

      // 退款信息
      getRefundInfo(data).then(res => {
        const { status, message } = res;
        if (status == 200) {
          this.$set(this.satisObj.refundPrice, 'num', message.totalRefundAmt ? Number(message.totalRefundAmt) / 100 : 0);
          this.$set(this.satisObj.refundNum, 'num', message.orderNum ? Number(message.orderNum) : 0);
        }
      });

      // 支付信息
      getPaymentInfo(data).then(res => {
        const { status, message } = res;
        if (status == 200) {
          this.$set(this.satisObj.payment, 'num', message.totalPaymentAmt ? Number(message.totalPaymentAmt) / 100 : 0);
        }
      });
      // 报名人数
      const result = await getStuEnrollNum(data);
      if (result.status == 200) {
        this.$set(this.satisObj.stuEnrollNum, 'num', result.message);

        // 报名率
        if (this.satisObj.stuEnrollNum.num && this.basicData[2].value) {
          const signPercent = parseFloat((this.satisObj.stuEnrollNum.num / this.basicData[2].value).toFixed(4)) * 100;
          this.$set(this.satisObj.signPercent, 'num', signPercent);
        } else {
          this.$set(this.satisObj.signPercent, 'num', 0);
        }

        // 报名人次
        getEnrollNum(data).then((res) => {
          const { status, message } = res;
          if (status == 200) {
            this.$set(this.satisObj.enrollNum, 'num', message);
            if (this.satisObj.enrollNum.num && this.satisObj.stuEnrollNum.num) {
              const courseSignNum = parseFloat((this.satisObj.enrollNum.num / this.satisObj.stuEnrollNum.num).toFixed(1));
              this.$set(this.satisObj.courseSignNum, 'num', courseSignNum);
            } else {
              this.$set(this.satisObj.courseSignNum, 'num', 0);
            }
          }
        });
      }
      this.loadingFun = false;
    },
    getMain() {
      const { areaCode, orgId: bureauId } = this.userInfo;
      const data = {
        areaCode,
        bureauId,
        yearCode: this.yearCode,
        termCode: this.termCode
      };
      getBigdataReport(data).then((res) => {
        console.log(this.yearCode, this.termCode);

        const { status, message } = res;
        if (status === 200) {
          let { schoolCt, studentCt, instCt } = message;
          if (this.yearCode == 8 && this.termCode == 1) {
            schoolCt = 66;
            instCt = 49;
            studentCt = 60678;
          }
          if (this.yearCode == 7 && this.termCode == 2) {
            schoolCt = 66;
            instCt = 49;
            studentCt = 55262;
          }
          this.basicData = [
            {
              label: '学校数',
              value: schoolCt
            },
            {
              label: '机构数',
              value: this.yearCode == 8 && this.termCode == 2 ? 60 : instCt
            },
            {
              label: '学生数',
              value: studentCt
            }
          ];
          // cardList已经配置好各种字段，这里只要取值
          this.cardList = this.cardList.map(item => ({
            ...item,
            num: message[item.key],
            // 是否要转换数据单位
            showNum: item.transform ? +item.transform(message[item.key]) : (item.key == 'rgbks' ? Number(message['zbkrc']) / Number(message['bmrs']) : (+message[item.key]))
          }));
        }
      });
    },
    // 学年学期change
    handleChangeSelect(key, value) {
      localStorage.setItem(key, this[value]); // 存储上次的选择
      // this.getMain();
      this.getNewStatisc();
    },
    handleFullScreen() {
      const isSafari = !!document.webkitCancelFullScreen;
      const flag = document.fullscreenElement || document.webkitIsFullScreen;
      if (flag) {
        isSafari ? document.webkitCancelFullScreen() : document.exitFullscreen();
      } else {
        const dom = document.querySelector('.ivu-layout-content');
        isSafari ? dom.webkitRequestFullscreen() : dom.requestFullscreen();
      }
    }
    // timestampToTime(times) {
    //   const time = times[1];
    //   let mdy = times[0];
    //   mdy = mdy.split('/');
    //   const month = parseInt(mdy[0]);
    //   const day = parseInt(mdy[1]);
    //   const year = parseInt(mdy[2]);
    //   return year + '-' + month + '-' + day + ' ' + time;
    // }
  }
};
</script>

<style lang="scss" scoped>
.piewrap {
  display: flex;
  width: 100%;
  margin-top: 30px;

  .dh {
    height: 400px;
  }
}

.picebox {
  display: flex;
  flex: 1;
  border: 1px solid #edecec;
  border-radius: 10px;
  justify-items: center;
  align-items: center;
  flex-direction: column;
  background-color: white;
}

.picebox:nth-child(2n) {
  margin-left: 20px;
}

.wraptitle {
  display: flex;
  flex: 1;
  padding: 15px 30px 10px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.titlefont {
  font-size: 16px;
  font-weight: 600;
}

.flex {
  display: flex;
  align-items: center;
}

.flex-end {
  justify-content: flex-end;
}

.school-home {
  height: 100%;
  min-width: 1200px;
  padding: 16px;

  .sticky {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .basic-info {
    padding: 8px 20px;
    background-color: rgba(240, 244, 249, 1);

    .info-item {
      font-size: 14px;
      color: #8690a5;
      margin-right: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .select {
    margin: 0 30px;
  }

  .tool-btn {
    .full-screen {
      cursor: pointer;
      transition: all 0.3s ease-in-out;

      &:hover {
        transform: rotate(180deg);
      }
    }
  }

  main {
    .card-box {
      flex-wrap: wrap;

      .card-item {
        width: calc(20% - 20px * 3 / 4);
        min-height: 130px;
        margin-top: 20px;
        margin-right: 15px;
        padding: 15px;

        &:nth-child(5n) {
          margin-right: 0;
        }

        &:hover {
          cursor: pointer;
          box-shadow: 0px 0px 10px #8a9fb7;

          .card-title {
            color: #1989fa;
          }
        }

        .card-title {
          font-size: 18px;
          color: #7f7f7f;
          margin-bottom: 30px;
        }

        .card-content {
          .card-num {
            font-size: 24px;
            color: #444;
            font-weight: bold;
            margin-right: 5px;
          }

          .card-unit {
            font-size: 16px;
            color: #7f7f7f;
          }

          .no-data {
            padding-bottom: 12px;
            text-align: center;
            font-size: 16px;
            color: #7f7f7f;
          }
        }
      }
    }
  }
}
</style>
